import { Icon } from '@timeedit/ui-components';
import type { DropdownProps, MenuProps } from '@timeedit/ui-components/antd';

type GetMenuPropsParams<T> = {
  record: T;
  onCompare?: (record: T) => void;
  onDuplicate?: (record: T) => void;
  onDelete?: (record: T) => void;
  checkDrawerOpen?: () => boolean;
  title?: string;
};

export const getMenuProps = <T,>({
  record,
  onCompare,
  onDuplicate,
  onDelete,
  checkDrawerOpen,
  title,
}: GetMenuPropsParams<T>): DropdownProps['menu'] => {
  const items: MenuProps['items'] = [];

  if (title) {
    items.push(
      {
        key: 'title',
        label: title,
        disabled: true,
      },
      {
        type: 'divider',
      }
    );
  }

  if (onCompare) {
    const isDrawerOpen = checkDrawerOpen?.() ?? true;
    items.push({
      key: 'compare',
      label: isDrawerOpen ? 'Compare' : 'Open',
      icon: <Icon id="EyeOutlined" alt="Eye" />,
    });
  }

  if (onDuplicate) {
    items.push({
      key: 'duplicate',
      label: 'Duplicate',
      icon: <Icon id="CopyOutlined" alt="Copy" />,
    });
  }

  if (onDelete) {
    items.push({
      key: 'delete',
      label: <span style={{ color: 'red' }}>Delete</span>,
      icon: <Icon id="DeleteOutlined" alt="Delete" style={{ color: 'red' }} />,
    });
  }

  const clickHandlerByKey: Record<string, ((record: T) => void) | undefined> = {
    compare: onCompare,
    duplicate: onDuplicate,
    delete: onDelete,
  };

  return {
    items,
    onClick: (info) => {
      info.domEvent.stopPropagation();
      clickHandlerByKey[info.key as string]?.(record);
    },
  };
};
